import React from "react";
import Slider from "react-slick";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  
  fan5,
  ac2,
  geyser1,
  dispenser3,
  refrigerator12,
} from "../../../assets/images/index";
import SampleNextArrow from "./SampleNextArrow";
import SamplePrevArrow from "./SamplePrevArrow";

const NewArrivals = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  return (
    <div className="w-full pb-16">
      <Heading heading="New Arrivals" />
      <Slider {...settings}>
        <div className="px-2">
          <Product
            _id="100001"
            img={fan5}
            productName="Royal Petite Bracket Fan"
            price="6900"
            color="Royal"
            badge={true}
            des="Be it your corridor, terrace, lobby, or veranda, the Royal Petite Fan is the best fit any place where space is limited. With its small wing blades and alluring shades of pearl white and impressive black, this fan is a petite powerhouse. "
          />
        </div>
        <div className="px-2">
          <Product
            _id="100002"
            img={ac2}
            productName="HAIER 1.5 TON TRIPLE INVERTER SPLIT AC"
            price="163800"
            color="HAIER"
            badge={true}
            des="The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
          />
        </div>
        <div className="px-2">
          <Product
            _id="100003"
            img={geyser1}
            productName="CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021"
            price="25500"
            color="CANON"
            badge={true}
            des="The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
          />
        </div>
        <div className="px-2">
          <Product
            _id="100004"
            img={dispenser3}
            productName="MIDEA THREE TAPS WATER DISPENSER Model"
            price="39600"
            color="MIDEA"
            badge={true}
            des="The Midea YL-2037S-B is a user-friendly water dispenser with a sleek design. It offers hot, normal, and cold water options, and is equipped with a refrigerator for added convenience."
          />
        </div>
        <div className="px-2">
          <Product
            _id="100005"
            img={refrigerator12}
            productName="HAIER REFRIGERATOR TWIN INVERTER IOT Model HRF-538TIFGU1"
            price="153000"
            color="HAIER"
            badge={true}
            des="The Twin Inverter IOT HRF-538TIFGU1 is a high-capacity refrigerator from Haier, launched in 2024. It features IoT technology, twin turbo fans, and A.SPE sterilization technology."
          />
        </div>
      </Slider>
    </div>
  );
};

export default NewArrivals;
